export class Appointment {
    idDossierMedical: string;
    idRdvMedical: string;
    dateDebut: string;
    dateFin: string;
    labelDate: string;
    labelPraticien: string;
    praticien: any;
}
